import { styled } from '@nx-kit/styling';
import { ComposedLink } from 'components/atoms/Link/Link';
import Container from 'components/layout/Grid/Container';

export const ContainerStyled = styled(Container)`
  margin-top: 40px;
`;

export const SpanSourseStyled = styled.span`
  color: ${({ theme }) => theme.global.color.gray180};
  font-size: ${({ theme }) => theme.global.fontSize.small}px;
  margin-right: 5px;
`;

export const ComposedLinkStyled = styled(ComposedLink)`
  color: ${({ theme }) => theme.global.color.gray900};
  font-size: ${({ theme }) => theme.global.fontSize.small}px;
  text-decoration: underline;
`;
